import AdminTime from "./AdminTime";

export default AdminTime;
